import * as constants from './config/constants.js';
import RequestHandler from './utils/request-handler.js';
import LoadingOverlay from './loading-overlay.js';

export default class Accessibility {
    constructor() {
        this.decisionElements = document.querySelectorAll('[data-accessibility-decision] input[type="radio"]');
        this.thirdPartyCodeElements = document.querySelectorAll('[data-accessibility-third-party-code]');
        this.requestHandler = new RequestHandler;
        this.responseMessage = document.querySelector('[data-accessibility-response-message]');
        this.loadingOverlay = new LoadingOverlay;
    }

    setup() {
        this.setupDecisionSelectionListener();
        this.setupThirdPartyCodeSelectionListener();
    }

    setupDecisionSelectionListener() {
        this.decisionElements.forEach((el) => {
            this.accessibilityAjaxCall(el, 'accessibilityDecision');
        });
    }

    setupThirdPartyCodeSelectionListener() {
        this.thirdPartyCodeElements.forEach((el) => {
            this.accessibilityAjaxCall(el, 'accessibilityThirdPartyCode');
        });
    }

    accessibilityCallBack(response) {
        if (response.message) {
            this.responseMessage.innerText = response.message;
        } else {
            this.responseMessage.innerText = 'An unexpected error occurred. Please try again;';
        }
        this.responseMessage.classList.remove(constants.ALERT_ERROR_CLASS, constants.ALERT_SUCCESS_CLASS);
        this.responseMessage.classList.add(constants.ALERT_CLASS);

        if (response.result == 'success') {
            this.responseMessage.classList.add(constants.ALERT_SUCCESS_CLASS);
        } else {
            this.responseMessage.classList.add(constants.ALERT_ERROR_CLASS);
        }
        this.loadingOverlay.taskFinished();
    }

    accessibilityAjaxCall(el, name) {
        el.addEventListener('change', (e) => {
            const publicId = e.target.closest('[data-accessibility-basket-section]').dataset.dealLinePublicId;
            const thirdPartyCodeElementId = `#form_${publicId}-accessibility_accessibilityThirdPartyCode`;
            const thirdPartyCodeElement = document.querySelector(thirdPartyCodeElementId);
            let data = `publicId=${publicId}&${name}=${e.target.value}`;

            if (name == 'accessibilityDecision' && e.target.value == 1
                && (!thirdPartyCodeElement.hasOwnProperty('value') || thirdPartyCodeElement.value == '')) {
                return;
            }

            if (name == 'accessibilityThirdPartyCode') {
                if (e.target.value == '') {
                    return;
                }
                if (data.includes('accessibilityDecision') == 0) {
                    const additionalParam = '&accessibilityDecision=1';
                    data = data.concat(additionalParam);
                }
            }
            this.loadingOverlay.taskStarted();
            this.requestHandler.post('/basket/accessibility',
                data,
                this.accessibilityCallBack.bind(this)
            );
        });
    }
}
